import {
    GET_ZIP,
    GET_ZIP_SUCCESS,
    GET_ZIP_FAILURE,
    DELETE_ZIP,
    DELETE_ZIP_SUCCESS,
    DELETE_ZIP_FAILURE,
    UPDATE_ZIP_STATUS,
    UPDATE_ZIP_STATUS_SUCCESS,
    UPDATE_ZIP_STATUS_FAILURE,
    GET_STATES,
    GET_STATES_SUCCESS,
    GET_STATES_FAILURE,
    EDIT_ZIP,
    EDIT_ZIP_SUCCESS,
    EDIT_ZIP_FAILURE,
    ADD_ZIP,
    ADD_ZIP_SUCCESS,
    ADD_ZIP_FAILURE,
    IMPORT_ZIP_DATA,
    IMPORT_ZIP_DATA_SUCCESS,
    IMPORT_ZIP_DATA_FAILURE
} from "../Constants";

const init = {
    data: {},
    states_data: {},
    edit_data: {},
    add_data: {},
    delete_data:{},
    import_data: {}
};

const ZipReducer = (state = init, action) => {
    switch (action.type) {
        case GET_ZIP:
            return { ...state, table_loading: true };
        case GET_ZIP_SUCCESS:
            return { ...state, table_loading: false, data: action.payload };
        case GET_ZIP_FAILURE:
            return { ...state, table_loading: false, data: action.payload };
        case DELETE_ZIP:
            return { ...state, loading: true };
        case DELETE_ZIP_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_ZIP_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        case UPDATE_ZIP_STATUS:
            return { ...state, loading: true };
        case UPDATE_ZIP_STATUS_SUCCESS:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_ZIP_STATUS_FAILURE:
            return { ...state, loading: false, status_data: action.payload };
        case GET_STATES:
            return { ...state, loading: true };
        case GET_STATES_SUCCESS:
            return { ...state, loading: false, states_data: action.payload };
        case GET_STATES_FAILURE:
            return { ...state, loading: false, states_data: action.payload };
        case ADD_ZIP:
            return { ...state, loading: true };
        case ADD_ZIP_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_ZIP_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_ZIP:
            return { ...state, loading: true };
        case EDIT_ZIP_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_ZIP_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case IMPORT_ZIP_DATA:
            return { ...state, loading: true };
        case IMPORT_ZIP_DATA_SUCCESS:
            return { ...state, loading: false, import_data: action.payload };
        case IMPORT_ZIP_DATA_FAILURE:
            return { ...state, loading: false, import_data: action.payload };
        default:
            return state;
    }
};

export default ZipReducer;